import React from 'react'
import { Typography, Link, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Image from 'next/image'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '20px',
    [theme.breakpoints.up('sm')]: {
      padding: '8rem 120px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '8rem 160px',
    },
  },
  sectionTitle: {
    fontFamily: theme.typography.h1.fontFamily,
    fontWeight: 'bold',
    fontSize: '1rem',
  },
  textSection: {
    '&>div': {
      padding: '0 2rem',
    },
  },
  link: {
    fontSize: '1rem',
  },
  description: {
    fontSize: '1rem',
    margin: '.4rem 0 1rem',
  },
}))

function QuickLinks(): JSX.Element {
  const classes = useStyles({})
  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4} className={classes.textSection}>
          <div>
            <Image src={'/svg/book.svg'} height={48} width={48} />
            <Typography variant="h6" className={classes.sectionTitle}>
              Academy
            </Typography>
            <Typography variant="body2" className={classes.description}>
              Browse videos, guides, and courses to start out in the crypto world.
            </Typography>
            <Link
              href="/academy"
              color="textSecondary"
              underline="always"
              component="a"
              className={classes.link}
            >
              Learn More
            </Link>
          </div>
        </Grid>

        <Grid item xs={12} md={4} className={classes.textSection}>
          <div>
            <Image src={'/svg/broadcast.svg'} height={48} width={48} />
            <Typography variant="h6" className={classes.sectionTitle}>
              Podcasts
            </Typography>
            <Typography variant="body2" className={classes.description}>
              Explore about everything that’s poppin’ in Crypto.
            </Typography>
            <Link
              href="/podcasts"
              color="textSecondary"
              underline="always"
              component="a"
              className={classes.link}
            >
              Learn More
            </Link>
          </div>
        </Grid>

        <Grid item xs={12} md={4} className={classes.textSection}>
          <div>
            <Image src={'/svg/users.svg'} height={48} width={48} />
            <Typography variant="h6" className={classes.sectionTitle}>
              Community
            </Typography>
            <Typography variant="body2" className={classes.description}>
              See what we do on social. Explore Podcasts, quick tips etc.
            </Typography>
            <Link
              href="/community"
              color="textSecondary"
              underline="always"
              component="a"
              className={classes.link}
            >
              Learn More
            </Link>
          </div>
        </Grid>
      </Grid>
    </div>
  )
}

export default QuickLinks
